import { io, Socket } from 'socket.io-client';
import { API_URL } from './api.config';

/**
 * Crée et configure une connexion Socket.IO
 * @param options Options supplémentaires pour la connexion Socket.IO
 * @returns Une instance de Socket.IO configurée
 */
export const createSocketConnection = (options = {}): Socket => {
    // Options par défaut pour Socket.IO
    const defaultOptions = {
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 10
    };

    // Fusionner les options par défaut avec les options fournies
    const socketOptions = {
        ...defaultOptions,
        ...options
    };

    return io(API_URL, socketOptions);
};